"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'grouphisai'
});